<template>
    <div class="Page">
        <!--Banner-->
        <section class="">
            <div class="banner">
                <h1 class="PageTitle" style="">OPPORTUNITÉS D’EMPLOI</h1>
            </div>
            <div class="orangeStripe"></div>
        </section>
        <!--JobText-->
        <section>
            <v-row class="jobBg">
                <v-col cols="12"><h2 class="sectionTitle">NOS POSTES DISPONIBLES</h2></v-col>
                <v-col cols="12" class="jobText">
                    <p>Tu souhaites faire partie d’une organisation dynamique dans le domaine&nbsp;du&nbsp;transport&nbsp;?</p>
                    <p>Tu auras le choix de te joindre à l’une de nos équipes dans l’un de nos 22 concessionnaires répartis à travers la province. Pour ce faire, consulte nos opportunités d’emploi ci-bas selon nos&nbsp;différentes&nbsp;places&nbsp;d’affaires.</p>
                </v-col>
            </v-row>
        </section>
        <!--JobsList-->
        <section>
            <v-row class="JobsListBg ">
                <v-col class="JobItem">
                    <a href="https://cyberimpact.page/ckhd3m24/Emplois_mecanicien-ne-s" target="_blank">
                        <h2>Technicien(ne) en mécanique <span style="color:gray">(concessionnaire de votre choix – partout dans notre réseau)</span></h2>
                    </a>
                </v-col>
                <v-col v-for="(item,i) in this.jobs" :key="i" class="JobItem">                   
                    <router-link :to="GetPath(item)">
                        <h2>{{item.title}} <span style="color:gray">({{item.branch}})</span></h2>   
                    </router-link>    
                </v-col>
                <v-col style="margin-top:50px;">
                    <hr style="width:100%;"/>      
                    <p>Aucun poste ne correspond à votre profil? Vous êtes intéressés par une carrière chez nous?</p>
                    <p>Soumettez votre candidature et nous vous contacterons lorsqu'un poste correspondra à votre profil.</p>
                    <router-link to="/postuler/9999" class="NoJobTitle">Candidature spontanée </router-link>
                </v-col>
                
            </v-row>
        </section>
        <!--newsletters-->
        <section>
            <div class="orangeStripe"></div>
                <v-row class="bgBlack">
                    <v-col cols="12" md="6" class="textAlignement">
                        <h2 class="sectionTitle">RESTEZ INFORMÉ(E)S&nbsp;!</h2>
                        <p class="sectionSubtitle spaceNewsletter">Abonnez-vous à notre infolettre du Réseau Dynamique pour recevoir les premiers nos promotions, événements, du contenu exclusif&nbsp;et&nbsp;plus&nbsp;encore&nbsp;!</p>
                        <a href="https://app.cyberimpact.com/clients/47814/subscribe-forms/8F9576B8-21A3-49D4-9B9C-DA19428BAE27" target="_Blank"><button style="" class="priBtn spaceNewsletter">S’inscrire</button></a>
                    </v-col>
                    <v-col class="">
                    </v-col>
            </v-row>
        </section>
    </div>
  </template>
  <style scoped>
        .padOpportunities { padding: 0px 100px; }
        .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/career/bannerOpportunities.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
        .jobBg { padding: 50px 100px; background-color: black; }
        .jobTitle {color: rgb(var(--secondary)); text-transform: uppercase; font-family: TxtOffBDI; font-size: 28px; }
        .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
        .jobText { color: white; margin-top: 20px; }

        .JobsListBg { min-height: 200px; background-color: rgb(var(--ligthGray)); padding: 50px; } 
        .JobsListBg h2:hover { color: rgb(var(--secondary)); }
        .JobItem { min-width: 100%; text-transform: uppercase; font-family: TxtOffBDI; }
        .JobItem:hover { color: rgb(var(--primary)); cursor: pointer;  }
        .NoJobTitle { color: rgb(var(--primary)); cursor: pointer; font-weight: 700; }
        .career-box {  position: relative; max-width: 700px; min-width: 700px; width: 700px; height: 600px; margin: 20px auto; perspective: 1000px;  }
        .career-box-Title { text-transform: uppercase; width: 100%; text-align: center; color: white; position: absolute; top:50%; left: 50%; transform: translate(-50%,-50%); font-family: TxtOffBDI; z-index: 100; }
        .career-box-Town { text-transform: uppercase; display: inline-block; width: 100%; text-align: center; color: white; font-family: TxtOffBDI;}
        .career-box-Town:hover { cursor: pointer; color: rgb(var(--primary));}
        .career-box:hover { cursor: pointer; }
        .career-box:hover .career-box-Title { color: rgb(var(--primary));  }
        .career-box img {position: relative; z-index: 10; width: 100%; height: 100%; object-fit: cover; object-position: center center; box-shadow: 0px 5px 10px 0px black; }
        .career-box-Shaddow { position: absolute; top:0px; z-index: 1; height: 700px; width: 800px; background-color: rgba(var(--black),0.5); margin: 50px auto; border-radius: 0% 0% 30% 30% / 0% 0% 30% 30%; }

        .card { width: 100%; height: 100%; position: absolute; backface-visibility: hidden; transition: transform 0.6s; }
        .dealerBack { transform: rotateY(180deg); }
        .career-box:hover .dealerBack { transform: rotateY(0deg); }
        .career-box:hover .dealerFront { transform: rotateY(180deg); }

        /*#region newsletter*/
        .bgNewsletter { display: block; background-image: url('../../public/ressources/images/home/infolettre.png'); background-position: center center; background-size: cover; background-repeat: no-repeat; }
        .bgBlack {background-color: black; }
        .textAlignement {padding: 2% 5% !important;}
        .spaceNewsletter { margin: 20px 0px; }
        /*#endregion*/
        @media handheld, only screen and (max-width: 600px) {
            .career-box { height: 300px; width: 500px; margin: 20px auto; }
            .career-box-Title { font-size: 18px; }
            .page { overflow-y:hidden; }
        }
        @media handheld, only screen and (max-width: 960px) {
            .jobBg { padding: 10px; background-color: black; }
            .JobsListBg { padding: 10px; } 
        }
        @media handheld, only screen and (max-width: 1279px) {}
        @media handheld, only screen and (max-width: 1378px) {}
  </style>
  <script>
  
  export default {
    name: 'opportunities',
    data:()=>({
        jobs:null,
        jobsTest:null,
        jobsData:null,
        jsonDealers:null,
    }),
    async mounted() {
        await this.dealersJsonRead();
        await this.jobRead();
    },
    methods:{
        jobsJsonRead: async function () {
            try {
                const response = await fetch('/ressources/json/jobs.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch');
                }
                this.jobs = await response.json();

            } catch (error) {
                console.error('Error loading JSON data:', error);
            }
        },
        dealersJsonRead: async function () {
            try {
                const response = await fetch('/ressources/json/dealers.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch');
                }
                this.jsonDealers = await response.json();
            } catch (error) {
                console.error('Error loading JSON data:', error);
            }
        },
        jobRead: async function() {
            let api = 'https://reseaudynamique.com/ressources/api/jobs.php';
            try {
                const response = await fetch(api);
                if (!response.ok) {
                    throw new Error('Failed to fetch');
                }
                this.jobsData = await response.json();

            } catch (error) {
                console.error('Error loading JSON data:', error);
            }

            try {

                let data = this.jobsData;
                //await data.forEach(async e => {
                    //let job;
                    //if(e.dealersKey){
                        //e = this.feedDealer(e)
                    //}
                //});
                this.jobs = data;

                
            } catch (error) {
                console.error('Error loading JSON data:', error);
            }
        },
        findJob: async function(jobKey){
            let jobSelected;
            try {
                let f = this.jobs.find( e => e.UId == jobKey);
                if(f){jobSelected = f;}
                
            } 
            catch (error) { this.errorMessage = "Une erreur c'est produite dans la fiche technique"; }
            return jobSelected;
        },
        feedDealer: function(job) {           
            let jobSelected = job;
            try {
                if(jobSelected){
                    if(this.jsonDealers){
                        if(jobSelected){                            
                            let f = this.jsonDealers[jobSelected.dealersKey];
                            if(f){jobSelected.dealer.push(f);}
                        }
                        
                    } else { console.log('') }
                }               
            } 
            catch (error) { this.errorMessage = "Une erreur c'est produite dans la fiche technique"; console.log(error); }

            return jobSelected;
        },
        GetPath: function(item){
            let url = "/travail";
            url = url + "/" + item.id;
            return url;
        }
    },
    components: { }
  }
  </script>
  